import { loadStripe, Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    stripePromise = key ? loadStripe(key) : Promise.resolve(null)
  }
  return stripePromise
}

/**
 * Which Stripe the card forms talk to, from the publishable key: `test`
 * (pk_test_: no real charges), `live` (pk_live_), `missing` (no key, so no
 * card form can work) or `unknown` (something else).
 */
export type StripeKeyMode = 'test' | 'live' | 'missing' | 'unknown'

export const stripeKeyMode = (
  key: string | undefined = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
): StripeKeyMode => {
  if (!key) return 'missing'
  if (key.startsWith('pk_test_')) return 'test'
  if (key.startsWith('pk_live_')) return 'live'
  return 'unknown'
}
